import { ListItem } from "common/Lists/types";

export const getItem = <T extends any>(
  displayName: string,
  selectHandlerItem: T,
  getIconValue?: string,
  errorMessage?: string
): ListItem<T> => {
  return {
    displayName,
    selectHandlerItem: selectHandlerItem,
    getIconValue: getIconValue || displayName,
    errorMessage,
  };
};
